/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Normalized_Power_One_LinerInputs */

const en_exp_normalized_power_one_liner = /** @type {(inputs: Exp_Normalized_Power_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The true intensity of your ride, accounting for the extra cost of surging and recovering.`)
};

const de_exp_normalized_power_one_liner = /** @type {(inputs: Exp_Normalized_Power_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die wahre Intensität deiner Fahrt — berücksichtigt die Extrakosten von Antritten und Pausen.`)
};

/**
* | output |
* | --- |
* | "The true intensity of your ride, accounting for the extra cost of surging and recovering." |
*
* @param {Exp_Normalized_Power_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_normalized_power_one_liner = /** @type {((inputs?: Exp_Normalized_Power_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Normalized_Power_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_normalized_power_one_liner(inputs)
	return de_exp_normalized_power_one_liner(inputs)
});